import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "header-title ion-text-center white-bold" }, "Настройки", -1)),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Меню справа", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_toggle, {
                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuButtonChange($event))),
                checked: _ctx.menuButton.position === 'right'
              }, null, 8, ["checked"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Кэш", -1)
                ]))]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_ion_label, { slot: "end" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.bufferSizeHuman), 1)
                ]),
                _: 1
              }, 512), [
                [_vShow, !_ctx.removingCache]
              ]),
              _withDirectives(_createVNode(_component_ion_icon, {
                icon: _ctx.trashOutline,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearCacheExceptPlaylists('/'))),
                slot: "end"
              }, null, 8, ["icon"]), [
                [_vShow, _ctx.bufferSize > 0 && !_ctx.removingCache]
              ]),
              _withDirectives(_createVNode(_component_ion_spinner, {
                name: "bubbles",
                slot: "end"
              }, null, 512), [
                [_vShow, _ctx.removingCache]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Память устройства", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_label, { slot: "end" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${_ctx.deviceDiskFreeHuman} из ${_ctx.deviceDiskTotalHuman}`), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}